import api from "./api";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; ++i) out[i] = raw.charCodeAt(i);
  return out;
}

export function pushSupported() {
  return (
    typeof window !== "undefined" &&
    "serviceWorker" in navigator &&
    "PushManager" in window &&
    "Notification" in window
  );
}

export async function getPushPermission() {
  if (!pushSupported()) return "unsupported";
  return Notification.permission; // "default" | "granted" | "denied"
}

export async function subscribeToPush() {
  if (!pushSupported()) throw new Error("Push not supported on this device");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Notification permission was not granted");
  const reg = await navigator.serviceWorker.ready;
  const { data } = await api.get("/push/vapid-key");
  if (!data.public_key) throw new Error("Server VAPID key missing");
  const sub = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(data.public_key),
  });
  const subJson = sub.toJSON();
  await api.post("/push/subscribe", {
    endpoint: subJson.endpoint,
    keys: subJson.keys,
    user_agent: navigator.userAgent,
  });
  return true;
}

export async function unsubscribeFromPush() {
  if (!pushSupported()) return;
  const reg = await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.getSubscription();
  if (sub) {
    const subJson = sub.toJSON();
    await api.post("/push/unsubscribe", {
      endpoint: subJson.endpoint,
      keys: subJson.keys || {},
    }).catch(() => {});
    await sub.unsubscribe();
  }
}

export async function sendTestPush() {
  await api.post("/push/test");
}

export async function isCurrentlySubscribed() {
  if (!pushSupported()) return false;
  try {
    const reg = await navigator.serviceWorker.ready;
    const sub = await reg.pushManager.getSubscription();
    return !!sub;
  } catch {
    return false;
  }
}
